/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { type Meta, type StoryObj } from '@storybook/react-vite';

import { ToolCall } from '../ToolCall';
import {
  ToolCallDefault,
  ToolCallDefaultSrc,
  ToolCallDone,
  ToolCallDoneSrc,
} from '.';

const componentMeta: Meta<typeof ToolCall> = {
  component: ToolCall,
  id: 'components-ai-tool-call',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/AI/ToolCall',
};

export default componentMeta;

type Story = StoryObj<typeof componentMeta>;

export const Default: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ToolCallDefaultSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ToolCallDefault,
};

export const Done: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ToolCallDoneSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ToolCallDone,
};
